import { formatEntityOptions, ValueField } from 'app/modules/search/helpers';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FilterMoreDisplay } from 'app/modules/filters/components/FilterMoreDisplay';
import { selectSearchV2UseDlHashIdEnabled } from 'app/shared/featureFlags/selectors';
import { useEntitiesForFilterDisplay } from 'app/modules/entities/queries/useEntitiesForFilterDisplay';

interface Props {
  ids: string[];
  label: string;
  valueField: ValueField;
}

export const EntityFilterDisplay = (props: Props) => {
  const { ids, label, valueField } = props;

  const isSearchV2UseDLHashIdEnabled = useSelector(
    selectSearchV2UseDlHashIdEnabled,
  );

  const { entities: data } = useEntitiesForFilterDisplay({
    ids,
    valueField,
  });

  const entityOptionsMap = useMemo(
    () =>
      formatEntityOptions(
        data,
        undefined,
        valueField,
        true,
        isSearchV2UseDLHashIdEnabled,
      ).reduce(
        (acc, i) => ({
          ...acc,
          [i.value]: i,
        }),
        {},
      ),
    [data, valueField, isSearchV2UseDLHashIdEnabled],
  );

  const values = useMemo(
    () => ids.map((i) => entityOptionsMap[i]?.text || i),
    [entityOptionsMap, ids],
  );

  return (
    <>
      <b>{label}</b> is one of <FilterMoreDisplay values={values} />
    </>
  );
};
